import { LexicalNode, $applyNodeReplacement } from 'lexical';

import { FileNode } from './FileNode';

export function $createFileNode(
  id: string,
  name: string,
  size: number,
): FileNode {
  return $applyNodeReplacement(new FileNode(id, name, size));
}

export function $isFileNode(
  node: LexicalNode | null | undefined,
): node is FileNode {
  return node instanceof FileNode;
}
